import { Meta } from "@solidjs/meta";
import { HttpStatusCode } from "@solidjs/start";
import { Show } from "solid-js";
import LessonEditor from "~/pages/dev/lesson-editor/LessonEditor";

const IS_DEV = import.meta.env.DEV;

export const route = { info: { flat: true } };

export default function DevLessons() {
  return (
    <Show when={IS_DEV} fallback={<HttpStatusCode code={404} />}>
      <main>
        <Meta name="robots" content="noindex" />
        <LessonEditor />
      </main>
    </Show>
  );
}
